"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeEightBannerSectionGeneratedProps = {
    divSection0Div0Div0ClassName?: string;
    /** Default: "Welcome to Doccure" */
    divSection0Div0Div0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Advanced Eye" */
    divSection0Div0Div0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Care for" */
    divSection0Div0Div0Div0Div0Div0H10H1Text2?: ReactNode;
    divSection0Div0Div0Div0Div0Div0H10H1Visible?: boolean;
    divSection0Div0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "banner-icon" */
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-six-img1.jpg" */
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc?: string;
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible?: boolean;
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Clearer Vision" */
    divSection0Div0Div0Div0Div0Div0H10Span1SpanText?: ReactNode;
    /** Default: "#" */
    divSection0Div0Div0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "View All Services" */
    divSection0Div0Div0Div0Div0Div1Link0LinkText?: ReactNode;
    divSection0Div0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    divSection0Div0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    divSection0Div0Div0Div0Div0Div1Link1LinkHref?: string;
    /** Default: "Meet Our Team" */
    divSection0Div0Div0Div0Div0Div1Link1LinkText?: ReactNode;
    divSection0Div0Div0Div0Div0Div1Link1LinkVisible?: boolean;
    divSection0Div0Div0Div0Div0Div1Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0Div1Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "banner-icon" */
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-8.png" */
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-9.png" */
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-icon" */
    divSection0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-element-8.png" */
    divSection0ImageWithBasePath0ImageSrc?: string;
    divSection0ImageWithBasePath0ImageVisible?: boolean;
    divSection0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeEightBannerSectionGenerated: FC<HomeEightBannerSectionGeneratedProps> = ({
    divSection0Div0Div0Div0Div0Div0Div0DivText = "Welcome to Doccure",
    divSection0Div0Div0Div0Div0Div0H10H1Text = "Advanced Eye",
    divSection0Div0Div0Div0Div0Div0H10H1Text2 = "Care for",
    divSection0Div0Div0Div0Div0Div0H10H1Visible,
    divSection0Div0Div0Div0Div0Div0H10H1Renderer,
    divSection0Div0Div0Div0Div0Div0H10H1Props,
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt = "banner-icon",
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-six-img1.jpg",
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible,
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer,
    divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps,
    divSection0Div0Div0Div0Div0Div0H10Span1SpanText = "Clearer Vision",
    divSection0Div0Div0Div0Div0Div1Link0LinkHref = "#",
    divSection0Div0Div0Div0Div0Div1Link0LinkText = "View All Services",
    divSection0Div0Div0Div0Div0Div1Link0LinkVisible,
    divSection0Div0Div0Div0Div0Div1Link0LinkRenderer,
    divSection0Div0Div0Div0Div0Div1Link0LinkProps,
    divSection0Div0Div0Div0Div0Div1Link1LinkHref = "#",
    divSection0Div0Div0Div0Div0Div1Link1LinkText = "Meet Our Team",
    divSection0Div0Div0Div0Div0Div1Link1LinkVisible,
    divSection0Div0Div0Div0Div0Div1Link1LinkRenderer,
    divSection0Div0Div0Div0Div0Div1Link1LinkProps,
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner-icon",
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-8.png",
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    divSection0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageAlt = "banner-icon",
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-img-9.png",
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageVisible,
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    divSection0Div0Div0Div1Div0ImageWithBasePath1ImageProps,
    divSection0ImageWithBasePath0ImageAlt = "banner-icon",
    divSection0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-element-8.png",
    divSection0ImageWithBasePath0ImageVisible,
    divSection0ImageWithBasePath0ImageRenderer,
    divSection0ImageWithBasePath0ImageProps,
    divSection0Div0Div0ClassName,
}) => {
    return (
        <div className="hero-section-eight">
            <div data-template-tag="HeaderEight" />
            <section className="banner-section-eight">
                <div className="container">
                    <div className={divSection0Div0Div0ClassName ?? "row"}>
                        <div className="col-lg-6">
                            <div className="banner-content-eight">
                                <div className="section-header section-header-eight">
                                    <div className="section-sub-title">
                                        <span className="dot" />
                                        {divSection0Div0Div0Div0Div0Div0Div0DivText}
                                    </div>
                                    {renderNode(divSection0Div0Div0Div0Div0Div0H10H1Visible, divSection0Div0Div0Div0Div0Div0H10H1Renderer, (
                                        <h1 className="section-title mb-0" {...(divSection0Div0Div0Div0Div0Div0H10H1Props ?? {})}>
                                            {divSection0Div0Div0Div0Div0Div0H10H1Text}
                                            <br />
                                            {divSection0Div0Div0Div0Div0Div0H10H1Text2}
                                            {" "}
                                            <span className="img-container">
                                                {renderNode(divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible, divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer, (
                                                    <SmartImage src={divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc} alt={divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(divSection0Div0Div0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps ?? {})} />
                                                ))}
                                            </span>
                                            {" "}
                                            <br />
                                            <span className="text-gradient">{divSection0Div0Div0Div0Div0Div0H10Span1SpanText}</span>
                                        </h1>
                                    ))}
                                </div>
                                <div className="banner-btn-eight d-flex align-items-center gap-3 flex-wrap">
                                    {renderNode(divSection0Div0Div0Div0Div0Div1Link0LinkVisible, divSection0Div0Div0Div0Div0Div1Link0LinkRenderer, (
                                        <SmartLink href={divSection0Div0Div0Div0Div0Div1Link0LinkHref} className="btn btn-primary theme-8-btn" {...(divSection0Div0Div0Div0Div0Div1Link0LinkProps ?? {})}>
                                            <span className="icon">
                                                <i className="isax isax-arrow-right-3" />
                                            </span>
                                            {divSection0Div0Div0Div0Div0Div1Link0LinkText}
                                        </SmartLink>
                                    ))}
                                    {renderNode(divSection0Div0Div0Div0Div0Div1Link1LinkVisible, divSection0Div0Div0Div0Div0Div1Link1LinkRenderer, (
                                        <SmartLink href={divSection0Div0Div0Div0Div0Div1Link1LinkHref} className="btn btn-white theme-8-btn" {...(divSection0Div0Div0Div0Div0Div1Link1LinkProps ?? {})}>
                                            <span className="icon">
                                                <i className="isax isax-arrow-right-3" />
                                            </span>
                                            {divSection0Div0Div0Div0Div0Div1Link1LinkText}
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-img">
                                {renderNode(divSection0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, divSection0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={divSection0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={divSection0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(divSection0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(divSection0Div0Div0Div1Div0ImageWithBasePath1ImageVisible, divSection0Div0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={divSection0Div0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={divSection0Div0Div0Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid img-two" {...(divSection0Div0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(divSection0ImageWithBasePath0ImageVisible, divSection0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={divSection0ImageWithBasePath0ImageSrc} alt={divSection0ImageWithBasePath0ImageAlt} className="img-fluid element-eight-01" {...(divSection0ImageWithBasePath0ImageProps ?? {})} />
                ))}
            </section>
        </div>
    );
};

export default HomeEightBannerSectionGenerated;
